import { render, staticRenderFns } from "./PhotoBlockLight.vue?vue&type=template&id=29e89bab&scoped=true&lang=pug&"
import script from "./PhotoBlockLight.vue?vue&type=script&lang=js&"
export * from "./PhotoBlockLight.vue?vue&type=script&lang=js&"
import style0 from "./PhotoBlockLight.vue?vue&type=style&index=0&id=29e89bab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e89bab",
  null
  
)

export default component.exports